<template>
  <b-card-body>
    <b-form-row>
      <b-col>
        <b-form-group label="Voor wanneer">
          <b-input-group>
            <b-datepicker
              v-model="activiteit.deadline" 
              :state="activiteit.deadline != null"
              :date-format-options="{ year: '2-digit', month: '2-digit', day: '2-digit' }"
              label-no-date-selected="Voor..."
            />
            <b-input-group-append>
              <b-dropdown text="Q">
                <b-dropdown-item 
                  v-for="(i) in deadlineOpties" 
                  :key="i.date" 
                  @click="activiteit.deadline = i.date"
                >
                  in {{ i.label }}
                </b-dropdown-item>
              </b-dropdown>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col>
        <b-form-group label="Toegewezen aan">
          <b-input-group>
            <b-input-group-prepend 
              is-text
            >
              <font-awesome-icon 
                icon="user"
              />
            </b-input-group-prepend>
            <b-select 
              v-model="activiteit.toegewezen_aan"
              :state="activiteit.toegewezen_aan != null"
              :options="
                personen.map((o) => {
                  return {
                    text: o.Naam.split(' ')[0],
                    value: o,
                  };
                })
              "
            >
              <template #first>
                <b-form-select-option 
                  :value="null" 
                  disabled
                >
                  -- GEEN --
                </b-form-select-option>
              </template>
            </b-select>
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col>
        <b-form-group label="Controle door">
          <inspecteur-select
            :value="activiteit.gecontroleerd_door"
            :required="true"
            :allow-beheerders="true"
            :eigen-groep-alleen="true"
            @input="onControleInput"
          />
        </b-form-group>
      </b-col>
    </b-form-row>
    <b-form-group label="Notitie">
      <b-textarea v-model="activiteit.omschrijving" />
    </b-form-group>
    
    <unit :unit="activiteit.unit" />
    
    <slot />

    <b-form-group 
      :description="authdocpath" 
      label="Bijlagen"
    >
      <secure-upload
        :endpoint="authdocpath"
        @file-uploaded="activiteit.bijlagen.push($event)"
      />

      <b-container class="my-2 p-0"> 
        {{ activiteit.bijlagen.length }} bijlagen
      </b-container>

      <b-button 
        v-for="(doc, index) in activiteit.bijlagen" 
        :key="doc.document.public_id" 
        :href="doc.document.secure_url"
        variant="dark"
        target="_blank"
        pill
      >
        <font-awesome-icon icon="paperclip" />
        {{ doc.document.original_filename }}.{{
          doc.document.format
        }} ({{ formatBytes(doc.document.bytes) }})
        <b-button 
          size="sm"
          pill
          variant="secondary"
          @click="activiteit.bijlagen.splice(index, 1)"
        >
          <i class="fa fa-times" />
        </b-button>
      </b-button>
    </b-form-group>
  </b-card-body>
</template>
<script>

import { trajectenMixin } from "@/mixins/trajectenMixin";
import InspecteurSelect from '@/components/InspecteurSelect.vue';
import SecureUpload from '../../views/administratie/documenten/SecureUpload.vue';
import Unit from './Unit.vue';

export default {
    name: 'StandaardStap',
    components: { InspecteurSelect, SecureUpload, Unit },
    mixins: [ trajectenMixin ],
    props: {
      authdocpath: {
        type: String,
        default: null
      },
      activiteit: {
        type: Object,
        default: () => {
          return {
            omschrijving: null,
            bedrag: null,
            moment: null,
            gecontroleerd_Door: null,
            toegewezen_aan: null,
            deadline: null,
            bijlagen: []
          }  
        }
      }
    },
    computed: {
      deadlineOpties() {
        var last_days = [31,30,30,31];
        var j = new Date().getFullYear();
        return [...[1,2,3,4].map((q) => {
          return {
            label: 'Q' + q + ' ' + j,
            date: j + '-' + (q * 3) + '-' + last_days[q - 1]
          }
        })].concat(...[1,2,3,4].map((q)=> {
          return {
            label: 'Q' + q + ' ' + (j + 1),
            date: (j + 1) + '-' + (q * 3)   + '-' + last_days[q - 1]
          }
        }));
      }
    },
    methods: {
      // InspecteurSelect geeft {id, naam} terug; map naar het API formaat {Id, Naam}
      onControleInput(selectie) {
        this.activiteit.gecontroleerd_door = selectie
          ? { Id: selectie.id, Naam: selectie.naam }
          : null;
      },
      formatBytes(bytes, decimals = 2) {
        if (bytes === 0) return "0 Bytes";

        const k = 1024;
        const dm = decimals < 0 ? 0 : decimals;
        const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
        const i = Math.floor(Math.log(bytes) / Math.log(k));

        return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
      },
    },
}
</script>